import { render, staticRenderFns } from "./AppointmentStatus.vue?vue&type=template&id=569ce0d2&"
import script from "./AppointmentStatus.vue?vue&type=script&lang=js&"
export * from "./AppointmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports